/* ============
 * Actions for the auth module
 * ============
 *
 * The actions that are available on the
 * auth module.
 */

import Vue from 'vue';
import store from '@/store';
import AuthProxy from '@/proxies/AuthProxy';
import * as types from './mutation-types';
import JSEncrypt from 'jsencrypt';

export const check = ({ commit }) => {
  commit(types.CHECK);
};

export const login = ({ commit }, user) => {

  const proxy = new AuthProxy()

  proxy
  .publicKey()
  .then((response) => {

    const encrypt = new JSEncrypt()
    encrypt.setPublicKey(response.publicKey)
    user.password = encrypt.encrypt(user.password_plain)

    return proxy

  })
  .then( proxy => proxy.login(user) )
  .then( response => {

      if(response.header.returnCode === "OK") {

        // 비밀번호 변경
        if(response.pwResetYn === 'Y') {
            alert('임시로 발급해 드린 비밀번호를 변경하셔야 서비스를 이용하실 수 있습니다.')
            Vue.router.push({
              name: 'ChangePw'
            });
            return;
        }

        commit(types.LOGIN, response.token);
        store.dispatch('account/me');
        Vue.router.push({
          name: response.mainUrl
        });
        // 알림 보기
        let mainInfo = {
          show: true,
          roleCode: response.role,
        };

        if(response.role === 'ADMIN') {

          store.dispatch('common/showMainInfo', mainInfo);

        } else { // 공지 

          store.dispatch('common/showNoticeModal' )

        } 

        store.commit('common/DEFAULT_USER_STATUS', response.defaultUserStatus)

      } else if(response.header.returnCode === "JOIN_READY") {
        alert('아직 가입승인 대기중 입니다.\n가입승인이 처리된 이후에 로그인하실 수 있습니다.');
      } else {
        alert(response.header.resultMessages);
      }


  })
  .catch(() => {
    console.log('Request failed...');
  });

};

export const logout = ({ commit }) => {
  commit(types.LOGOUT);
  location.href = "/";
};

export default {
  check,
  login,
  logout,
};
